import { Form, InputGroup } from 'react-bootstrap';

// One debounced free-text box per list page. Debounce (350ms) lives in useFinanceQuery; this is
// just the controlled input on qDraft/setQDraft.
export default function FinanceSearchBar({ value, onChange, placeholder = 'Search…' }) {
  return (
    <InputGroup size="sm" className="finance-search-bar">
      <InputGroup.Text aria-hidden="true">🔍</InputGroup.Text>
      <Form.Control
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label="Search this list"
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          className="btn btn-outline-secondary"
          aria-label="Clear search"
          onClick={() => onChange('')}
        >
          ✕
        </button>
      )}
    </InputGroup>
  );
}
